<template>
  <div class="py-4 container-fluid">
    <div class="row">
    </div>
    <div class="row" style="min-height:380px;">
      <div class="card mb-4">
        <div class="card-header pb-0 border-bottom">
          <h6>صفحه اصلی</h6>
        </div>
        <div class="card-body px-0 pt-0 pb-2 ">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardService from "@/services/Dashboard-service";
  import CartableService from "@/services/Cartabel/Cartabel-service.js";

  export default {
    name: "dashboard",
    data() {
      return {
        Cartable_ApplyDateId: ''
      };
    },
    components: {
    },
    created() {
    },
    methods: {
      onCallbackDelete() {
      }
    },
    beforeUnmount() {
    }
  };
</script>
